import React from 'react'
import bsn from 'bootstrap.native'

export default class Modal extends React.Component {
    componentDidMount() {
        var modal = new bsn.Modal(this.modal)
        if(this.props.show !== false) {
            modal.show()
        }
    }
    render() {
        return (
            <div className="modal fade" ref={e => this.modal = e}>
                <div className="modal-dialog">
                    <div className="modal-content">{this.props.children}</div>
                </div>
            </div>
        )
    }
} 


// WEBPACK FOOTER //
// ./components/Modal.jsx